import messages from "../../../locale/messages";
import {
  containsMalicious,
  inputTextLimit,
} from "../../../helpers/textRestriction";

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = messages.required;
  } else if (values.name.trim() == "") {
    errors.name = messages.required;
  } else if (values.name && values.name.length > inputTextLimit) {
    errors.name = messages.inputFieldRestriction;
  } else if (containsMalicious(values.name)) {
    errors.name = messages.invalidInput;
  }

  return errors;
};

export default validate;
